import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { switchMap } from 'rxjs/operators';
import { ConfirmacaoService } from 'src/app/core/confirmacao/confirmacao.service';
import { Status } from 'src/app/core/framework/default.model';
import { ToasterService } from 'src/app/core/framework/toaster/toaster.service';

import { EnumUtil } from 'src/app/core/framework/utils/enum-util';
import { StringUtil } from 'src/app/core/framework/utils/string-util';
import { CfgIntegracaoEventoCliente } from '../../../model/cfg-integracao-evento-cliente.model';
import { CfgIntegracaoEvento } from '../../../model/cfg-integracao-evento.model';
import { CfgIntegracaoHttpMethod } from '../../../model/cfg-integracao-http-method.enum';
import { CfgIntegracaoEventoClienteService } from '../service/cfg-integracao-evento-cliente.service';


@Component({
  selector: 'app-cfg-integracao-evento',
  templateUrl: './cfg-integracao-evento.component.html',
  styleUrls: ['./cfg-integracao-evento.component.css']
})
export class CfgIntegracaoEventoComponent implements OnInit {

  static MODO_VISUALIZACAO = 'visualizacao';
  static MODO_EDICAO = 'edicao';

  @Input() cfgIntegracaoEvento: CfgIntegracaoEvento;
  public modo = CfgIntegracaoEventoComponent.MODO_VISUALIZACAO;
  public methodOptions: any[];

  public eventoCliente: CfgIntegracaoEventoCliente = null;

  public novaUrl: string = null;
  public novoMethod: CfgIntegracaoHttpMethod = null;

  constructor(
    private cfgIntegracaoEventoClienteService: CfgIntegracaoEventoClienteService,
    private toasterService: ToasterService,
    private confirmacaoService: ConfirmacaoService,
    private router: Router
  ) {
    this.methodOptions = EnumUtil.toArray(CfgIntegracaoHttpMethod);
  }

  ngOnInit(): void {
    if ( this.cfgIntegracaoEvento && this.cfgIntegracaoEvento['data'] ) {
      if ( this.cfgIntegracaoEvento['data'].cfgIntegracaoEventosCliente
           && this.cfgIntegracaoEvento['data'].cfgIntegracaoEventosCliente.length > 0 ) {
        this.eventoCliente = this.cfgIntegracaoEvento['data'].cfgIntegracaoEventosCliente[0];
      }
    }
  }

  abrirLog(): void {
    this.router.navigate(['/seguranca/configuracao/cfg-integracao-evento-log', this.cfgIntegracaoEvento['data'].id]);
  }

  editar(): void {
    if ( !this.eventoCliente ) {
      this.eventoCliente = new CfgIntegracaoEventoCliente();
    }

    this.novaUrl = this.eventoCliente.url;
    this.novoMethod = this.eventoCliente.method;
    this.modo = CfgIntegracaoEventoComponent.MODO_EDICAO;
  }

  cancelarEdicao(): void {
    this.modo = CfgIntegracaoEventoComponent.MODO_VISUALIZACAO;
  }

  inativar(): void {
    this.confirmacaoService
        .confirmarAtualizacao(
          () => {
            this.cfgIntegracaoEventoClienteService
                .excluir(this.eventoCliente.id)
                .pipe(
                  switchMap(() => {
                    return this.cfgIntegracaoEventoClienteService.fetch(this.eventoCliente.id)
                  })
                )
                .subscribe((result: CfgIntegracaoEventoCliente) => {
                  this.atualizarInterfaceDepoisDeSalvar(result);
                })
          }
        );
  }

  ativar(): void {
    if ( !StringUtil.validarUrl(this.eventoCliente.url) ) {
      this.toasterService.warning('Favor informar uma URL válida');
      return;
    }

    this.confirmacaoService
        .confirmarAtualizacao(
          () => {
            this.cfgIntegracaoEventoClienteService
                .ativar(this.eventoCliente.id)
                .subscribe((result: CfgIntegracaoEventoCliente) => {
                  this.atualizarInterfaceDepoisDeSalvar(result);
                });
          }
        ) 
  }

  private atualizarInterfaceDepoisDeSalvar(result: CfgIntegracaoEventoCliente): void {
    this.cfgIntegracaoEvento['data'].method = result.method;
    this.cfgIntegracaoEvento['data'].url = result.url;
    this.cfgIntegracaoEvento['data'].status = result.status;

    this.eventoCliente = result;

    this.toasterService.success();
    this.modo = CfgIntegracaoEventoComponent.MODO_VISUALIZACAO;
  }

  criarOuAtualizar(): void {
    if ( this.novaUrl !== '' && !StringUtil.validarUrl(this.novaUrl) ) {
      this.toasterService.warning('Favor verificar a URL', this.novaUrl);
      return;
    }

    this.confirmacaoService
        .confirmarAtualizacao(
          () => {
            const o: CfgIntegracaoEventoCliente = this.cfgIntegracaoEvento['data'];
            o.idCfgIntegracaoEvento = o.id;
            o.status = ( this.eventoCliente.status === '' ? Status.ATIVO : this.eventoCliente.status);
            
            o.url = this.novaUrl.trim();
            o.method = ( this.novoMethod ? this.novoMethod : CfgIntegracaoHttpMethod.POST );
        
            this.cfgIntegracaoEventoClienteService
                .criarOuAtualizar(o)
                .subscribe((result: CfgIntegracaoEventoCliente) => {
                  this.atualizarInterfaceDepoisDeSalvar(result);
                });
          }
        );
  }

}
